import {
  CREATE_USER_API,
  BASE_URL,
  GET_USER_LIST_API,
  DOWNLOAD_USER_LIST_API,
  DOWNLOAD_ENTITY_MASTER_EXCEL_API,
  DELETE_USER_BY_UUID_API
} from '../endpoints/apiEndpoints'
import { getAccessToken } from '../utils/session'

export async function saveUser(payload) {
  const {
    editUserId,
    username,
    emailId,
    isActive,
    roleTypes,
    isLocked,
    isSSOUser,
    name,
  } = payload || {}

  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')
  const res = await fetch(`${BASE_URL}/${CREATE_USER_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      accept: 'application/json',
    },
    body: JSON.stringify([
      {
        ...(editUserId && { userId:editUserId }),
        username: username,
        name: name,
        emailId: emailId,
        isAdmin: false,
        isActive: isActive,
        isLocked: isLocked,
        isSSOUser: isSSOUser,
        roleTypes: [roleTypes],
      },
    ]),
  })

  if (!res.ok) throw new Error(`Failed to create user: ${res.status}`)
  return await res.json()
}

export async function getUsers(payload) {  

   const defaultPayload = {
          pageFilter: {
            currentPage: 1,
            includeCount: true,
            pageSize: 100,
            sortField: 'lastModifiedDate',
            sortOrder: 'DESC',
          },
          requestFilter: [],
          isReportDownload: false,
          searchCOList: []
      }

  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')
  const res = await fetch(`${BASE_URL}/${GET_USER_LIST_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload ? payload : defaultPayload),
  })

  if (!res.ok) throw new Error(`Failed to get users: ${res.status}`)
  return await res.json()
}


export async function downloadUserExcel(payload) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${DOWNLOAD_USER_LIST_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  })

  if (!res.ok) throw new Error(`Failed to download TAN Master Excel: ${res.status}`)
  
  // Return as Blob (Excel file)
  const blob = await res.blob()
  return blob
}

export async function downloadEntityExcel(payload) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${DOWNLOAD_ENTITY_MASTER_EXCEL_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  })

  if (!res.ok) throw new Error(`Failed to download TAN Master Excel: ${res.status}`)
  
  // Return as Blob (Excel file)
  const blob = await res.blob()
  return blob
}

export const deleteUser = async (payload, isDelete) => {
    const accessToken = getAccessToken()
    if (!accessToken) throw new Error('Missing access token in sessionStorage')
  
    const response = await fetch(`${BASE_URL}/${DELETE_USER_BY_UUID_API}?isDelete=${isDelete}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([payload]),
    })
  
    if (!response.ok) {
      let errorMessage
      try {
        const errorData = await response.json()
        errorMessage =
          errorData.error || `Request failed with status: ${response.status}`
      } catch {
        errorMessage = `Request failed with status: ${response.status}`
      }
      throw new Error(errorMessage)
    }
  
    // If API returns no content (like 204), skip JSON parsing
    let data = null
    if (response.status !== 204) {
      try {
        data = await response.json()
      } catch {
        data = null
      }
    }
  
    return {
      success: true,
      data,
    }
};